<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"    
    :table-items="lotItems"
    :indexNested="true"
    :maskFields="maskFields"
    :disablePagination="true"
    :hasTableTitle="hasTableTitle"
    :customExpandIcon="true"
    :tableTitle="tableTitle"
    :addAndEdit="addAndEdit"
    :containSearchBar="false"    
  >
    <template slot="new" v-if="!readOnly && addAndEdit && packaging">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
        :packaging="packaging"
        :itemLots="itemLots"
        :movementItem="movementItem"
        :seedPlotOperation="seedPlotOperation"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
        :packaging="packaging"
        :itemLots="itemLots"
        :movementItem="movementItem"
        :seedPlotOperation="seedPlotOperation"
      />
    </template>

    <template slot="edit" v-if="!readOnly && addAndEdit && packaging" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
        :packaging="packaging"
        :itemLots="itemLots"
        :movementItem="movementItem"
        :seedPlotOperation="seedPlotOperation"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
        :itemLots="itemLots"
      />
    </template>    

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      // tableHeaders: [],
      maskFields: [

        { field: 'unitPrice', mask: 'currency_10d' }, 
        { field: 'quantity', mask: 'number'},
        { field: 'packagingQuantity', mask: 'number'},
        { field: 'price',mask: 'currency'},
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    lotItems: {
      type: Array,
      default(){
        return [];
      },
    },
    movementItem: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    hasTableTitle: {
      type: Boolean,
      default: false
    },
    tableTitle: {
      type: String
    },
    modelNameSingular: {
      type: String,
      default: "Lote"
    },
    modelNamePlural: {
      type: String,
      default: "Lotes"
    },
    addAndEdit: {
      type: Boolean,
      default: true,
    },
    packaging: Object,
    itemLots: {
      type: Array,
      default: new Array(),
    },
    seedPlotOperation: Object,
  },
  created() {
    // console.log("is new item storage", this.isNewItemInStorage);
    // console.log("lotItems", this.lotItems);
    // console.log("itemLots", this.itemLots); 
  },
  computed: {
    tableHeaders() {
      return [
        { text: "Lote", align: "left", sortable: true, value: "newName" },
        { text: "Qtd. de emb.", align: "left", sortable: true, value: "packagingQuantity" },
        { text: "Qtd.", align: "left", sortable: false, value: "quantity" },
        // { text: "Und.", align: "left", sortable: true, value: "item.unit.name" },
        // { text: "R$ Total", align: "left", sortable: false, value: "price" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        { text: "Ações", value: "action", sortable: false }
      ]
    }
  },
  methods: {
    entryUpdated: function(editedPurchaseItem){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
      this.recalculatePurchaseTotalPrice();
    },
    entryCreated: function(newLotItem){
      // console.log("lotitem", newLotItem);
      // this.lotItems = [];            
      this.lotItems.push(newLotItem);
      // console.log("lotItems index", this.lotItems);
      newLotItem.quantity = newLotItem.quantity;
      this.$refs.baseIndex.showConfirmationCreateMessage();
      this.$emit("update:inputData", this.lotItems);
      this.recalculatePurchaseTotalPrice();
    },
    entryDeleted: function(deletedPurchaseItem){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
      this.recalculatePurchaseTotalPrice();
    },
    recalculatePurchaseTotalPrice: function() {
      var newPurchaseTotalPrice = 0;
      // for (var purchase in this.lotItems) {
      //   if(!this.lotItems[purchase]._destroy) {
      //     newPurchaseTotalPrice += this.lotItems[purchase].price;
      //   }
      // }
      // newPurchaseTotalPrice = _.round(newPurchaseTotalPrice, 2);
    //   this.$emit('update:purchaseTotalPrice', newPurchaseTotalPrice);
    }
  }
};
</script>

<style scoped></style>
